export default {
  methods: {
    selectPaymentOption(index) {
      const checkout = this.checkout;
      checkout.paymentOption = this.paymentOptions[index];

      this.$store.dispatch('SET_CHECKOUT', checkout);

      let step =  checkout.coupon ? 6 : this.checkoutStep + 1;
      this.$store.dispatch('SET_CHECKOUT_STEP', step);
    }
  },
  created() {
    this.$emit('info', this.$t('payment'));
  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  },
};
